<ion-row class="itinerary-row" id="passengersSection">
  <ion-col>
    <h6>Passenger's Information</h6>
    <ion-row size="12" *ngIf="allLeadguests">
      <div class="w-100">
      </div>
    </ion-row>

    <ion-row size="12" *ngIf="allLeadguests">
      <div class="w-100">
        <app-passengers-grid-view 
        [allData]="allLeadguests" [columns]="leadPassengersColumns"
        (paginationsUpdated)="getAllContacts($event)"
        (triggerDeleteRow)="deletePassengerRow($event)"
        (triggerEditRow)="editPassengerOpen($event)"
        (triggerViewRow)="viewPassenger($event)"
        ></app-passengers-grid-view>
      </div>
    </ion-row>

    <ion-row>
      <ion-button class="unfilled-blue-btn" (click)="openContactForm()">
        Add Passenger
      </ion-button>
    </ion-row>
  </ion-col>
</ion-row>